// cspell:disable
export const BANNER_1_CONTENT = {
  mainText: `Nós usamos cookies para coletar dados pessoais, e estamos de acordo com a LGPD para realizar a coleta, o tratamento e o compartilhamento desses dados.`,
  dataText: `Os dados que coletaremos é sobre a sua navegação no site, escolhas e buscas realizadas. Nosso objetivo é criar métricas para melhorar o nosso negócio.`,
  privacyText: "Saiba mais em nossa",
  privacyLink: "política de privacidade",
  privacyUrl: "https://www.gov.br/pt-br/termos-de-uso",
  subtext:
    "Quando fizer sua escolha, não se preocupe, o banner será minimizado.",
  buttons: {
    accept: "Aceitar",
    reject: "Recusar",
    manage: "Gerenciar",
  },
};

export const BANNER_2_CONTENT = {
  mainText: `Usamos cookies para coletar dados de como é a sua interação com o site, clicks, pesquisas, escolhas, perfil. Para isso, seguimos as normas da LGPD.`,
  purposeText: `Nossa finalidade é entregar conteúdos mais próximos do seu interesse e aumentar o engajamento com o site.`,
  subtext: `Ao confirmar suas escolhas ou recusar todos, o banner será minimizado. Assim, você pode reabrir e mudar quando quiser.`,
  cookiesLink: "Declaração de cookies",
  cookiesUrl: "https://www.gov.br/pt-br/termos-de-uso",
  buttons: {
    confirm: "Confirmar escolhas",
    rejectAll: "Recusar todos",
  },
  toggles: [
    {
      id: "analytics",
      title: "Cookie de Linguagem:",
      description:
        "Serve para redirecionar a pessoa para a pasta de idioma correta. Dura 7 dias.",
    },
    {
      id: "marketing",
      title: "Cookie de Captcha:",
      description:
        "Tem como finalidade fornecer a análise de risco do usuário. Dura 180 dias.",
    },
  ],
};

export const BANNER_3_CONTENT = {
  mainText: `Nós usamos cookies! Estamos de acordo com a LGPD para lidar com os seus dados de forma segura.`,
  dataText: `Coletamos dados de como você interage na nossa plataforma, quais são os conteúdos que te interessam, e qual o seu perfil, para melhorar a priorização de conteúdos que sejam do seu interesse.`,
  privacyText: "Para maiores detalhes acesse o nosso",
  privacyLink: "Termo de privacidade",
  privacyUrl: "https://www.gov.br/pt-br/termos-de-uso",
  subtext:
    "Ao finalizar com o banner, ele será minimizado, você pode mudar as escolhas sempre que quiser!",
  buttons: {
    acceptNecessary: "Aceitar somente os essenciais",
    acceptAll: "Aceitar todos",
    manage: "Gerenciar",
  },
};
